<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <div class="title-section">
        <h2>Create New User</h2>
      </div>
      <mat-icon class="close-icon" (click)="close()">close</mat-icon>
    </div>

    <div class="modal-body">
      <form [formGroup]="form" class="form-body">
        <div class="form-row">
          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>User Name</mat-label>
            <input matInput formControlName="userName" placeholder="Enter user's full name">
            <mat-error *ngIf="form.get('userName')?.hasError('required') && form.get('userName')?.touched">
              * User name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>User Email</mat-label>
            <input matInput formControlName="userEmail" placeholder="name@vetcor.com">
            <mat-error *ngIf="form.get('userEmail')?.hasError('required') && form.get('userEmail')?.touched">
              * Email is required
            </mat-error>
            <mat-error *ngIf="form.get('userEmail')?.hasError('email') && form.get('userEmail')?.touched">
              * Enter a valid email address
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>User Status</mat-label>
            <mat-select formControlName="userStatus">
              <mat-option *ngFor="let s of statusList" [value]="s">{{ s }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('userStatus')?.hasError('required') && form.get('userStatus')?.touched">
              * Status is required
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>User Type</mat-label>
            <mat-select formControlName="userType">
              <mat-option *ngFor="let t of typeList" [value]="t">{{ t }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('userType')?.hasError('required') && form.get('userType')?.touched">
              * User type is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>User Role</mat-label>
            <mat-select formControlName="userRole">
              <mat-option *ngFor="let r of roleList" [value]="r">{{ r }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('userRole')?.hasError('required') && form.get('userRole')?.touched">
              * User role is required
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>Last Logged In</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="lastLoggedIn">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field form-half-width" appearance="outline">
            <mat-label>Hospital Assignment Source</mat-label>
            <mat-select formControlName="assignmentSource">
              <mat-option *ngFor="let a of assignmentSourceList" [value]="a">{{ a }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('assignmentSource')?.hasError('required') && form.get('assignmentSource')?.touched">
              * Assignment source is required
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button mat-stroked-button class="cancel-btn" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" class="submit-btn" (click)="submit()">Create User</button>
    </div>
  </div>
</div>
